import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Payment } from '../../models/payment';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient) { }

  public getPaymentsByInvoiceId(invoiceId: number) : Observable<any>
  {
    return this.http.get<any>(`${environment.API_URL}/payments/${invoiceId}`);
  }

  public updatePaymentByInvoiceId(invoiceId: number, payments: Payment[], toBeDeleted: number[]) : Observable<Payment[]> {
    return this.http.post<Payment[]>(`${environment.API_URL}/payments/update`, {invoiceId: invoiceId, payments: payments, toBeDeleted: toBeDeleted});
  }
}
